import IN from './en-IN.json';
import US from './en-US.json';

const domain = window.location.hostname;
const getConfigJSON = dm => {
  if (dm === 'localhost' || dm.split('.').indexOf('com') > -1) {
    return { JSON: US, region: 'US', currency: 'USD', code: 'en-us' };
    // eslint-disable-next-line no-else-return
  } else {
    return { JSON: IN, region: 'IN', currency: 'INR', code: 'en-in' };
  }
};
export default getConfigJSON(domain);
